import { render, staticRenderFns } from "./RatePlan.vue?vue&type=template&id=42384266&"
import script from "./RatePlan.vue?vue&type=script&lang=js&"
export * from "./RatePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports